(function($) {
    $(window).scroll(function () {
        if ( ( $(this).scrollTop() - 420) > 0) {
            $('#scroller').fadeIn();
        } else {
            $('#scroller').fadeOut();
        }
    });
    $('#scroller').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 750);
        return false;
    });

    $(".video-wrapper .cover").click(function(){
        $(this).hide();
    });

    if ($('.top-slider').length) {
        var top_slider = tns({
            useLocalStorage: false,
            container: '.top-slider',
            items: 1,
            slideBy: 1,
            loop: true,
            mouseDrag: true,
            nav: true,
            controls: false,
            navPosition: "bottom",
            fade: true,
            speed: 500,
            gutter: 0,
            preventScrollOnTouch: 'auto'
        });
    }

    $('.menu-mobile .level-1 > .nav-link.mobile-dropdown-toggle').on('click', function(e){
        e.preventDefault();
        $('.menu-mobile .level-2.dropdown .dropdown-menu').hide();
        $(".menu-mobile .dropdown-back").hide();
        $('.menu-mobile .level-1 .dropdown-menu').hide();
        $(this).next('.dropdown-menu').show(); //.toggleClass('show');
    });

    $('.menu-mobile .level-2.dropdown .nav-link.mobile-dropdown-toggle .arrow').on('click', function(e){
        e.preventDefault();
        $(".menu-mobile .dropdown-back").show(10);
        $('.menu-mobile .level-2.dropdown .dropdown-menu').hide();
        $(this).parent().next('.dropdown-menu').show(); //toggleClass('show');
    });

    $('.menu-mobile .dropdown-close').on('click', function(e){
        e.preventDefault();
        $(".menu-mobile .dropdown-back").hide(10);
        $(this).parents('.dropdown-menu').hide(); //.removeClass('show');
    });

    $(".menu-mobile .dropdown-back").on('click', function (){
        var that = this;
        $('.menu-mobile .level-2.dropdown .dropdown-menu').hide(50);
        setTimeout(function (){
            if ($(".level-2.dropdown .dropdown-menu:visible").length < 1){
                $(that).hide();
            }
        }, 100);
    });

    if ($('.reviews-slider').length) {
        var reviews_slider = tns({
            useLocalStorage: false,
            container: '.reviews-slider',
            items: 1,
            slideBy: 1,
            loop: true,
            mouseDrag: true,
            nav: false,
            controls: true,
            controlsText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
            fade: true,
            speed: 500,
            gutter: 16,
            responsive: {
                "576": {
                    "items": 2
                },
                "768": {
                    "items": 3
                }
            },
            preventScrollOnTouch: 'auto'
        });
    }

    if ($('.simple-carousel').length) {
        var simple_carousel = tns({
            useLocalStorage: false,
            container: '.simple-carousel',
            items: 1,
            slideBy: 1,
            loop: true,
            mouseDrag: true,
            nav: false,
            controls: true,
            controlsText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
            fade: true,
            speed: 500,
            gutter: 16,
            responsive: {
                "576": {
                    "items": 2
                },
                "768": {
                    "items": 3
                }
            },
            preventScrollOnTouch: 'auto'
        });
    }

    $("[data-scroll]").on('click', function(){
        var target = $(this).data('target');
        var $target = $(target);
        $('html, body').animate({
            scrollTop: $target.offset().top - 100
        }, 1000);
    });

    var select2 = $('.styled2 select').select2({
        placeholder: 'Выбрать из списка',
        minimumResultsForSearch: Infinity
    });

    /*$('.styled2 select').trigger('change.select2');*/

    $('.styled select').on("change", function (e) {
        var selectedType = $(this).val();

        selectDoctors(selectedType);
    });

    $('.styled2 select').on("select2:select", function (e) {
        var selectedType = select2.val();

        selectDoctors(selectedType);

        var $diseasesList = $(".diseases-list");
        if ($diseasesList.length){

        }
    });

    $('a.review-toggle').on('click', function(e){
        e.preventDefault();
        $(this).parent().toggleClass('open');
        $(this).addClass('d-none');
    });

    $('#reviewModal').on('show.bs.modal', function (event) {
        var $source = $(event.relatedTarget); // Button that triggered the modal
        var $reviewWrapper = $source.closest(".review-item-wrap");

        var name = $reviewWrapper.find(".name").html();
        var date = $reviewWrapper.find(".date").html();
        var content = $reviewWrapper.find(".content").html();
        var docInfo = "";
        if($reviewWrapper.find(".doc-info").length){
            docInfo = $reviewWrapper.find(".doc-info").html();
        }

        // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
        var modal = $(this);
        modal.find('.modal-body').html("<div class='content'>" + content + "</div>");
        modal.find('.modal-body').prepend("<p class='date'>" + date + "</p>");
        modal.find('.modal-body').prepend("<p class='name'>" + name + "</p>");
        modal.find('.modal-body').append("<div class='doc-info'>" + docInfo + "</div>");
    });

})(jQuery);

function selectDoctors(selectedType) {
    var $doctorsList = $(".doctors-list");
    if ($doctorsList.length){
        $doctorsList.find(".doctor-item-wrapper").fadeOut(100);
        if(selectedType !== "all")
            setTimeout(function (){
                $doctorsList.find(".doctor-item-wrapper[data-type=" + selectedType + "]").fadeIn(100);
                setTimeout(function (){
                    if($doctorsList.find(".doctor-item-wrapper:visible").length < 1){
                        $(".doctors-list .default").show(10);
                    }else {
                        $(".doctors-list .default").hide(10);
                    }
                }, 200);
            }, 110);
        else {
            setTimeout(function (){
                $doctorsList.find(".doctor-item-wrapper").fadeIn(100);
                $(".doctors-list .default").hide(10);
            }, 110);
        }
    }
}
